import { AssetSectionGridLayout, CreateAssetSectionBody } from '@nusign/picflow-backend-types';

export const assetSectionSizes = { small: 32, medium: 38, large: 55 };
export const assetSectionSpacings = { small: 5, medium: 12, large: 30 };
export const sectionVerticalPadding = { small: 10, medium: 20, large: 30 };
export const sectionWidths = { small: 960, medium: 1280, full: 3840 };
export const assetSectionLayouts: AssetSectionGridLayout[] = ['columns', 'rows', 'grid'];

export const defaultAssetSection: Partial<CreateAssetSectionBody> = {
  grid_layout: assetSectionLayouts[0],
  width: sectionWidths.medium,
  display_size: assetSectionSizes.medium,
  spacing: assetSectionSpacings.medium,
  sorting: 'name',
};
export const defaultGallerySection: Partial<CreateAssetSectionBody> = {
  sorting: 'title',
};
